export default "__VITE_IMAGE_ASSET__2c5c7d89__";